import { Injectable } from '@angular/core';
import { Route, UrlSegment, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable,pipe  } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { UserAuthenticationServices } from './user-authentication.services';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(private authService: UserAuthenticationServices, private router: Router) {
 
  }
  
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const url: string = state.url;
      
      return this.authService.getAuthenticated(next);
      // if ( this.authService.getAuthenticated(next)){
      //   return true;
      // }else{
      //   return 
      //   //return this.router.parseUrl('/auth');
      // }
     
  }
  
  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      
    return true;
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }
}
